import {
  GET_INTEGRATION,
  CREATE_INTEGRATION,
  UPDATE_INTEGRATION,
  DELETE_INTEGRATION,
} from 'actions/types';

let integrationList = [];
const initialState = { data: [], isLoading: false };

export function integration(state = initialState, action) {
  const { type, payload } = action;
  if (type === GET_INTEGRATION) {
    return { ...state, isLoading: true };
  }
  if (type === `${GET_INTEGRATION}_SUCCESS`) {
    integrationList = payload;
    return { data: integrationList, isLoading: false };
  }
  if (type === `${CREATE_INTEGRATION}_SUCCESS`) {
    const created = payload;
    const data = [...integrationList, created];
    integrationList = data;
    return { data: integrationList, isLoading: false };
  }
  if (type === `${DELETE_INTEGRATION}_SUCCESS`) {
    const { id } = payload;
    const data = [...integrationList].filter((i) => id !== i.id);
    integrationList = data;
    return { data: integrationList, isLoading: false };
  }
  if (type === `${GET_INTEGRATION}_FAILURE`) {
    return { ...state, error: payload, isLoading: false };
  }
  if (type === `${UPDATE_INTEGRATION}_SUCCESS`) {
    const { id, updatedValues } = payload;
    const data = integrationList.map(function (integration) {
      if (id === integration.id) {
        return { ...integration, ...updatedValues };
      }
      return integration;
    });
    integrationList = data;
    return { data: integrationList, isLoading: false };
  }
  return state;
}
